import { render } from "./dro-layout-empty.vue?vue&type=template&id=6f141002"
const script = {}

import "./dro-layout-empty.vue?vue&type=style&index=0&id=6f141002&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__